module.exports = __webpack_public_path__ + "static/media/ic_empty.51bc2a67.svg";